import { createFileRoute, notFound } from '@tanstack/react-router';

import { LookbookRecordPage } from '@/features/lookbooks/LookbookRecordPage';

export const Route = createFileRoute('/_app/lookbooks/$lookbookId')({
    component: LookbookRoute,
});

function LookbookRoute() {
    const { lookbookId } = Route.useParams();
    const id = Number(lookbookId);
    // A junk id in the URL is a dead link, not a record: the not-found page says so rather than
    // the record page asking the API about NaN.
    if (!Number.isInteger(id) || id <= 0) {
        throw notFound();
    }
    return <LookbookRecordPage lookbookId={id} />;
}
